import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { GlobalComponent } from "../../global/global.component";
import { IMyDpOptions } from 'mydatepicker';
import { DateService } from '../../date.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FilterSettingsModel, GridComponent, PageSettingsModel, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { DataStateChangeEventArgs, SearchSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { GroupPayorServiceTableBO, sortingObj, grp, filters, GetGroupPayorServiceBO, WhereCondition, functionpermission, columnWidth, ColumnChangeBO, UpdateRatesInBulk } from './group-payor-mapping.model';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonApiService } from 'src/app/commonapiservice';
declare var $: any;
@Component({
  selector: 'app-group-payor-mapping',
  templateUrl: './group-payor-mapping.component.html',
  styleUrls: ['./group-payor-mapping.component.scss'],
})
export class GroupPayorMappingComponent implements OnInit {
  @ViewChild('grid') public grid: GridComponent;
  private onDestroy$: Subject<void> = new Subject<void>();
  filterOptions: FilterSettingsModel;
  dropInstance: DropDownList;
  public searchSettings: SearchSettingsModel;
  public toolbar: ToolbarItems[];
  searchText: any = "";
  searchColumn: any = "groupName";
  error: any = ''
  MasterserviceId: any = ""
  public sortColumn: any = "id";
  public orderType: any = "asc";
  public isDesc: any = false;
  SearchText: string = '';
  GroupPayorServiceDataList: any = [];
  SearchColumn: { [key: string]: string } = { 'groupName': 'Group' };
  togglebool: boolean = false
  pageSize: any = 20;
  groupId: any;
  perPage: any = 20;
  currentPage: any = 1;
  totalPage: any;
  pagshort: sortingObj = new sortingObj();
  GroupPayorService: GroupPayorServiceTableBO = new GroupPayorServiceTableBO();
  GroupPayorServiceArray: GroupPayorServiceTableBO[];
  grp: grp = new grp;
  billingUnit: any = [];
  type: string = "";
  billingUnit1: any = [];
  groupUnit: any[];
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: true,
    editableDateField: true,
    height: '30px'
  };
  SearchColum: string = 'groupName';
  Filter_Group: string = '';
  Filter_Payor: string = '';
  filter_service: string;
  filter_billingUnitLid: string = '';
  filter_name: string = '';
  filter_FacilityId: string = ''
  groupPayerForm: FormGroup;
  payerLst: any;
  groupLst: any;
  providerList: any;
  exampleFlag: boolean = false;
  Allservice: any = [];
  servicedata: any = [];
  AllPayerLst: any = [];
  payorEnable: boolean;
  Addgrpser: boolean = false;
  updategrpser: boolean = false;
  TotalCount: number;
  filter: filters = new filters();
  filterSelect: any;
  valuechange: any = [];
  showErrorAlert: boolean = false
  deleteError: any = "";
  deleteAlert: boolean = false;
  ListSendBO: GetGroupPayorServiceBO = new GetGroupPayorServiceBO();
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  ColumnArray: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  arraycol: any = [];
  isSaveorUpdateBoolean: boolean = false;
  public isinitialLoad: boolean = false;
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  initialPage: PageSettingsModel;
  public filterSettings: object;
  fp: functionpermission;
  stateList: any = []
  updateRatesInBulk: UpdateRatesInBulk = new UpdateRatesInBulk();
  statusList:any;
  filterstatusList:any;
  FilterStatus:any;
  constructor(public CommonAPI: CommonApiService,public router: Router, public dateservice: DateService,  private datepipe: DatePipe, public http: HttpClient, public toastrService: ToastrService, public global: GlobalComponent, private formBuilder: FormBuilder, private cdr: ChangeDetectorRef,) {
    this.global.agencyList();
    this.data = CommonAPI;
    this.groupPayerForm = this.formBuilder.group({
      agencyId: [this.global.globalAgencyId],
      icd10: [''],
      isIcd10FromClient: [true],
      groupId: [''],
      groupName: [''],
      payorName: [''],
      groupPayorId: [0, Validators.required],
      masterServiceId: [0, Validators.required],
      serviceDescription: [''],
      billingUnitLid: [0, Validators.required],
      serviceName: [''],
      billingUnit: [''],
      netRate: ['', Validators.required],
      unitrate: ['', Validators.required],
      hCPCCode: [''],
      callTypeID: [''],
      unitMultiplier: [''],
      billIndividually: [''],
      revCode: [''],
      providerLid: ['', Validators.required],
      companyIdentifier: [true],
      g2id: [''],
      nPI: [''],
      companyName: [''],
      name: [''],
      address1: [''],
      address2: [''],
      city: [''],
      state: [''],
      zipCode: [''],
      facilityID: [''],
      serviceLoc: ['', Validators.required],
      pharm: [''],
      homeVisit: [''],
      rateChangeDate: [null],
      oldUCRate: [''],
      oldNetRate: [''],
      waiverFlag: [false],
      combineClaim: [false],
      taxonomyCode: [''],
      umpiPayorUMPIMust: [''],
      atypical: [],
      status:[],
      claimAttachment:[],
      supervisingProvider:[],
      referringProvider:[]

    });

  }
  message: string = 'loading :(';
  ngAfterContentChecked() {
    this.message = 'all done loading :)'
    this.cdr.detectChanges();
  }
  ngOnInit() {
     if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == 0||this.global.globalAgencyId=='00000000-0000-0000-0000-000000000000') {
      return;
    }
    this.CommonAPI.getStateJson().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
    });
    this.conditionlist.push(new WhereCondition());
    this.toolbar = ['ColumnChooser'];
    this.fp = new functionpermission();
    this.filepermissionget();
    this.filterSettings = { type: 'Menu' };
   // let pag = JSON.parse(this.global.globalColumn.column)[0]?.GrouppayorService.Pagesize;
   let pag= 10;
    this.initialPage = {
      currentPage: 1,
      pageSizes: this.pageSizes,
      pageSize: pag,
    };
    this.ListSendBO.pageitem = pag;
    this.SearchColumn.key = 'groupName';
    this.SearchColumn.value = 'Group';
    this.toolbar = ['ColumnChooser'];
    this.groupPayerForm.get('groupPayorId').disable()
    this.getGroup();
    this.getService();
    this.getBillingStatus()
    this.getProviderDropDown();
    this.getAllpayer();
    this.getStatusLov();
  }
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ListSendBO.orderColumn = state.sorted[0].name;
        this.ListSendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.ListSendBO.field = state.action.currentFilterObject.field;
      this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListSendBO.operator = state.action.currentFilterObject.operator;
      this.ListSendBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.ListSendBO.field = "groupName";
        this.ListSendBO.matchCase = false;
        this.ListSendBO.operator = "startswith";
        this.ListSendBO.value = "";
      }
    } if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].GrouppayorService.Pagesize != state.take) {
          this.arraycol[0].GrouppayorService.Pagesize = state.take
          this.SaveColumnwidth();
        }
      }
    }
    this.getPayorTotalItem();
  }
  showtable() {
    this.updategrpser = false;
    this.Addgrpser = false;
  }
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  clearfilter() {
    this.filter.groupId = '0';
    this.filter.groupPayorId = '0';
    this.filter.service = '0';
    this.filter.name = "";
    this.filter.FacilityId = "";
    this.filter.billingUnitLid = '0';
  }
  public onActionComplete(args) {
    this.ListSendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.ListSendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].GrouppayorService.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].GrouppayorService.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (this.arraycol[0].GrouppayorService.ShowColumns.length != count1 || this.arraycol[0].GrouppayorService.HideColumns.length != count) {
          this.arraycol[0].GrouppayorService.ShowColumns = showarr;
          this.arraycol[0].GrouppayorService.HideColumns = hidearr;
          this.SaveColumnwidth();
        }
      }
    }
  }
  getPayorTotalItem() {
    let url = "api/PayerService/getPayorTotalItemFilter?"
    let responseData =
    {
      result: "lList",
      count: "totalCount",
    }
    this.ListSendBO.statusLid=this.FilterStatus?.toString()
    this.CommonAPI.outputValues(url, this.ListSendBO, responseData, "");
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.GroupPayorServiceDataList = data.result;
      count = count + 1
      if (data != null && data != undefined && count == 1) {
        if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
          // this.getColumnwidth();
        }
      }
      data.result.forEach(element => {
        element.groupPayorId = element.groupPayorId.toString();
      });
      if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
        if (data != null && data.result.length > 15) {
          this.grid.height = '500';
        }
        else {
          this.grid.height = 'auto';
        }
      }
    })
  }
  getGroupPayor() {
    let url = "api/PayerService/GetGroupPayorServiceTableList?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("",url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.GroupPayorServiceArray = data;
    })
  }
  applyFilter() {
    this.ListSendBO.field = this.filterSelect
    if (this.filterSelect == "payorName") {
      this.ListSendBO.value = this.filter.groupPayorId
      let val = this.filter.groupPayorId != undefined ? this.filter.groupPayorId :'00000000-0000-0000-0000-000000000000' ; this.clearfilter(); this.filter.groupPayorId = val
    }
    if (this.filterSelect == "Service") { let val = this.filter.service != undefined ? this.filter.service : '00000000-0000-0000-0000-000000000000'; this.clearfilter(); this.filter.service = val }
    if (this.filterSelect == "Group") { let val = this.filter.groupId != undefined ? this.filter.groupId : '00000000-0000-0000-0000-000000000000'; this.clearfilter(); this.filter.groupId = val }
    if (this.filterSelect == "Billing Unit") { let val = this.filter.billingUnitLid != undefined ? this.filter.billingUnitLid : '00000000-0000-0000-0000-000000000000'; this.clearfilter(); this.filter.billingUnitLid = val }
    if (this.filterSelect == "FacilityId") { let val = this.filter.FacilityId; this.clearfilter(); this.filter.FacilityId = val }
    if (this.filterSelect == "Facilityname") { let val = this.filter.name; this.clearfilter(); this.filter.name = val }
    this.getPayorTotalItem();
  }
  deleteDetails(details) {
    this.GroupPayorService.id = details;
  }
  DeleteGroupPayorServiceTable() {
    let params = new URLSearchParams();
    params.append("GroupId", this.GroupPayorService.id.toString());
    let url = "api/PayerService/DeleteGroupPayorServiceTable?";
    this.CommonAPI.DeleteFunctionForDeleteHttp(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success("Group Payor Service deleted successfully!")
      document.getElementById('openModal2').click();
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
      this.getPayorTotalItem();
    }, (err: any) => {
      this.toastrService.error(err, 'Error'), 8000;
    });
  }
  //   ///////////////////////////
  getGroup() {
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("ListCode", "PAYER");
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.groupLst = data;
    }
    )
  }
  groupchange(groupId, isCheck: boolean) {
    if (isCheck == true) {
      this.GroupPayorService.groupPayorId = null;
    }
    if (groupId == undefined || groupId == '' || groupId == null) {
      this.GroupPayorService.groupPayorId = null;
      this.payerLst = null;
      return;
    }
    else {
      this.groupPayerForm.get('groupPayorId').enable();
      this.getpayer(groupId);
    }
  }
  getpayer(groupId) {
    let url = "api/Payer/getpayerId?";
    let param = new URLSearchParams();
    param.append("groupId", groupId);
    this.CommonAPI.GetFunctionwithResponseTypeJson(param,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.payerLst = data;
      if (this.payerLst.length == 0) {
        this.GroupPayorService.groupPayorId = null;
      }
    })
  }
  getAllpayer() {
    let url = "api/Payer/CommonGetGPList?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("",url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      let temp: any = [];
      data.forEach(element => {
        temp = { label: element.Value, value: element.Key.toString() }
        this.AllPayerLst.push(temp);
      });
      this.AllPayerLst = data;
    })
  }
  getProviderDropDown() {
    let params = new URLSearchParams();
    params.append("ListCode", "RENDERINGPROVIDER");
    let url = "api/LOV/getLovDropDown?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      for (let i = 0; i < data.length; i++) {
        data[i].value = parseInt(data[i].value);
        if (data[i].label === "RN NPI") {
          this.exampleFlag = true;
        }
      }
      this.providerList = data;
    },
      err => {
      });
  }
  GrpCreateupdate(type: string,data:any) {
    if (type == 'new') {
      this.Addgrpser = true;
      this.updategrpser = false;
      this.groupPayerForm.reset();
      this.GroupPayorService = new GroupPayorServiceTableBO();
      this.MasterserviceId = ""
      this.GroupPayorService.statusLid="Active"
      this.groupPayerForm.get('status').setValue(this.GroupPayorService.statusLid);
    }
    else if (type == 'edit') {
      this.updategrpser = true;
    }
    this.valueschanges()
  }
  selectgrpdetails(Details: GroupPayorServiceTableBO) {
    this.GroupPayorService = Details;
    this.GroupPayorService.rateChangeDate = this.datepipe.transform(Details.rateChangeDate, "MM/dd/yyyy");
    this.GroupPayorService = JSON.parse(JSON.stringify(Details));
    this.MasterserviceId = this.GroupPayorService.masterServiceId.toString()
    this.groupId = this.GroupPayorService.groupId;
    this.GroupPayorService.groupId = this.groupId.toString();
    this.groupchange(this.GroupPayorService.groupId, false);
    this.GroupPayorService.statusLid=this.statusList?.filter(
      (st) => st.Key == Details.statusLid
    )[0].Value;
    this.groupPayerForm.get('status').setValue(this.GroupPayorService.statusLid);
  }
  getService() {
    let url = "api/Service/getCommonServicedropdown?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("",url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      data.forEach(element => {
        element.id = element.id.toString()
      });
      this.Allservice = data;
      this.Allservice.forEach(element => {
        element.Value = element.masterservice.toString();
        element.Key = element.id.toString();
      });
    })
  }
  serviceChange(service) {
    if (service == undefined) {
      this.GroupPayorService.serviceDescription = "";
    }
    else {
      let url = "api/Service/getDescription?";
      let param = new URLSearchParams();
      param.append("Id", service);
      this.CommonAPI.GetFunctionwithResponseTypeJson(param,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        data.forEach(element => {
          this.GroupPayorService.serviceDescription = element.description;
        });

      });
    }
  }
  getBillingStatus() {
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("ListCode", "BILLING");
    params.append("userId", this.global.userID);
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.billingUnit = data;
    },
      err => {
      });
  }
  newdates(event, type, name) {
    if (type == "inputchage") {
      if (name == 'rateChangeDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.GroupPayorService.rateChangeDate = val1;
        }
      }
      if (name == 'startDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.updateRatesInBulk.rateChangeDate = val1;
        }
      }
    }
    if (type == "datechagned") {
      if (name == 'rateChangeDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.GroupPayorService.rateChangeDate = val1;
        }
      }
      if (name == 'startDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.updateRatesInBulk.rateChangeDate = val1;
        }
      }
    }
  }
  //   /////////////////////////save Group payor Service////////////////////////
  SaveOrUpdateGroupPayorService() {
    this.isSaveorUpdateBoolean=true
    let url = "api/PayerService/SaveGroupPayorServiceTable";
    var saveList: any = JSON.parse(JSON.stringify(this.GroupPayorService));
    let val = this.Allservice.filter(s => s.id == this.MasterserviceId)[0]
    if (val.is837I) {
      if (saveList.revCode == "" || saveList.revCode == null || saveList.revCode == undefined) {
        this.toastrService.error("RevCode Mandatory", "Error")
        this.isSaveorUpdateBoolean=false
        return
      }
    }
    saveList.statusLid = this.statusList.filter(ele=>ele.id==saveList.statusLid)[0].id;
    saveList.groupId = this.GroupPayorService.groupId;
    saveList.groupPayorId = this.groupPayerForm.get('groupPayorId').value;
    saveList.masterServiceId = this.groupPayerForm.get('masterServiceId').value;
    saveList.callTypeID = this.groupPayerForm.get('callTypeID').value;
    saveList.providerLid =this.groupPayerForm.get('providerLid').value;
    saveList.billingUnitLid = this.groupPayerForm.get('billingUnitLid').value;
    saveList.companyIdentifier = Boolean(this.groupPayerForm.get('companyIdentifier').value);
    saveList.rateChangeDate = (saveList.rateChangeDate != null && saveList.rateChangeDate != undefined && saveList.rateChangeDate != '') ? this.global.getDateTimeString(this.GroupPayorService.rateChangeDate) : null;
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveList,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      //====================== sucess message =============
      this.isSaveorUpdateBoolean=false
      if (saveList.id == '00000000-0000-0000-0000-000000000000' || saveList.id == undefined) {
        saveList.id = data;
        this.toastrService.success('Group Payor Service created successfully!')
        this.getPayorTotalItem();
        this.showtable()
      }
      else if (saveList.id != '00000000-0000-0000-0000-000000000000' && saveList.id != undefined) {
        this.getPayorTotalItem();
        this.showtable()
        this.toastrService.success('Group Payor Service updated successfully!')
      }
      this.payerLst = [];
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false
      if (err) {
        this.error = err;
        this.showErrorAlert = true
      }
      else {
        this.error = JSON.stringify(this.error);
      }
      if (this.error != "") {
        setTimeout(() => {
          this.error = "";
          this.showErrorAlert = false
        }, 5000)
      }
    })
  }
  dateFormateyyyyMMdd(date: string) {
    let day = date.substring(0, 2);
    let month = date.substring(3, 5);
    let year = date.substring(6, 10);
    let days = +day;
    let months = +month;
    let years = +year;
    let newDate = new Date();
    newDate.setDate(days);
    newDate.setMonth(months - 1);
    newDate.setFullYear(years);
    return this.datepipe.transform(newDate, "yyyy-MM-dd")
  }
  Refresh() {
    this.ListSendBO.field = 'groupName';
    this.ListSendBO.value = "";
    this.ListSendBO.currentpageno = 1;
    this.filterSelect = ''
    this.Filter_Payor = '00000000-0000-0000-0000-000000000000'
    this.filter_FacilityId = ''
    this.filter_billingUnitLid = ''
    this.filter_name = ''
    this.filter_service = '00000000-0000-0000-0000-000000000000'
    this.ListSendBO.serviceId = '00000000-0000-0000-0000-000000000000';
    this.Filter_Group =  '00000000-0000-0000-0000-000000000000'
    let page =10;
    this.ListSendBO.pageitem = page;
    this.pagshort = new sortingObj();
    this.getPayorTotalItem();
    this.grid.clearFiltering();
    this.grid.clearSorting();
  }
  selected_filter(filter) {
    this.SearchColum = filter;
  }
  search(filter) {
    this.ListSendBO.field = (this.filterSelect != null && this.filterSelect != undefined && this.filterSelect != '') ? this.filterSelect : "payorName";
    if (this.ListSendBO.field == "serviceName") {
      this.ListSendBO.value = ""
      this.ListSendBO.serviceId = (this.filter_service != null && this.filter_service != undefined && this.filter_service != '00000000-0000-0000-0000-000000000000') ?this.filter_service.toString() : '00000000-0000-0000-0000-000000000000';
    }
    else {
      this.ListSendBO.serviceId = '00000000-0000-0000-0000-000000000000';
      this.ListSendBO.value = (filter != null && filter != undefined && filter != '') ? filter : "";
    }
    this.getPayorTotalItem();
  }
  //   // // ///////////////////////////////////////////////////////////
  onKeydown(event, filter) {
    if (event.key === "Enter") {
      this.search(filter);
    }
  }
  //   //////////////////////////////Set default value for searchcolumn////////////////////
  setDefaultValue() {
    this.SearchText = "";
    if (this.SearchColumn == undefined)
      this.SearchColumn = {
        'groupName': 'Group',
      };
  }
  // /////////////////////////////////////////////////////////////////
  actionHandler(args) {
    if (args.requestType == "sorting") {
    }
    else if (args.requestType == "filtering") {
    }
  }
  ////////////////////////////////get Zip code Function////////////////////////////////
  getzipcode() {
    let url1 = "api/Client/getZipcode?"
    let myParams1 = new URLSearchParams();
    myParams1.append("Street", this.GroupPayorService.address1)
    myParams1.append("City", this.GroupPayorService.city)
    myParams1.append("State", this.GroupPayorService.state)
    this.CommonAPI.GetFunctionwithResponseTypeJson( myParams1,url1).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.GroupPayorService.zipCode = data.zipcode;
    })
  }
  //////////////////////////////////value change///////////////////////////////////////
  valueschanges() {
    this.valuechange = {
      Status:0,
      Group: 0,
      Payor: 0,
      Service: 0,
      Description: 0,
      billingUnit: 0,
      netRate: 0,
      unitrate: 0,
      hcpcCode: 0,
      billIndividually: 0,
      revCode: 0,
      providerLid: 0,
      companyIdentifier: 0,
      g2id: null,
      npi: 0,
      companyName: 0,
      name: 0,
      address1: 0,
      address2: 0,
      city: 0,
      state: 0,
      zipCode: 0,
      facilityID: 0,
      serviceLoc: 0,
      pharm: 0,
      homeVisit: 0,
      callTypeID: 0,
      unitMultiplier: 0,
      rateChangeDate: 0,
      oldUCRate: 0,
      oldNetRate: 0,
      icd10: 0,
      icd10button: 0,
      isIcd10FromClient: 0,
      taxonomyCode: 0,
      waiverFlag: 0,
      atypical: 0,
      umpiPayorUMPIMust: 0,
      combineClaim: 0
    }
  }
  checkpopup(value) {
    if(value=='Status')
    {
       this.valuechange.Status++;
    }
    if (value == "Group") {
      this.valuechange.Group++;
    }
    if (value == "Payor") {
      this.valuechange.Payor++;
    }
    if (value == "Service") {
      this.valuechange.Service++;
    }
    if (value == "Description") {
      this.valuechange.Description++;
    }
    if (value == "billingUnit") {
      this.valuechange.billingUnit++;
    }
    if (value == "netRate") {
      this.valuechange.netRate++;
    }
    if (value == "unitrate") {
      this.valuechange.unitrate++;
    } if (value == "hcpcCode") {
      this.valuechange.hcpcCode++;
    } if (value == "billIndividually") {
      this.valuechange.billIndividually++;
    }
    if (value == "revCode") {
      this.valuechange.revCode++;
    }
    if (value == "providerLid") {
      this.valuechange.providerLid++;
    }
    if (value == "companyIdentifier") {
      this.valuechange.companyIdentifier++;
    }
    if (value == "g2id") {
      this.valuechange.g2id++;
    } if (value == "npi") {
      this.valuechange.npi++;
    }
    if (value == "companyName") {
      this.valuechange.companyName++;
    }
    if (value == "name") {
      this.valuechange.name++;
    }
    if (value == "address1") {
      this.valuechange.address1++;
    }
    if (value == "address2") {
      this.valuechange.address2++;
    }
    if (value == "city") {
      this.valuechange.city++;
    } if (value == "state") {
      this.valuechange.state++;
    } if (value == "zipCode") {
      this.valuechange.zipCode++;
    } if (value == "facilityID") {
      this.valuechange.facilityID++;
    }
    if (value == "serviceLoc") {
      this.valuechange.serviceLoc++;
    } if (value == "pharm") {
      this.valuechange.pharm++;
    } if (value == "homeVisit") {
      this.valuechange.homeVisit++;
    } if (value == "callTypeID") {
      this.valuechange.callTypeID++;
    } if (value == "unitMultiplier") {
      this.valuechange.unitMultiplier++;
    }
    if (value == "rateChangeDate") {
      this.valuechange.rateChangeDate++;
    }
    if (value == "oldUCRate") {
      this.valuechange.oldUCRate++;
    } if (value == "oldNetRate") {
      this.valuechange.oldNetRate++;
    } if (value == "icd10") {
      this.valuechange.icd10++;
    } if (value == "icd10button") {
      this.valuechange.icd10button++;
    }
    if (value == "isIcd10FromClient") {
      this.valuechange.isIcd10FromClient++;
    }
    if (value == "waiverFlag") {
      this.valuechange.waiverFlag++;
    }
    if (value == "combineClaim") {
      this.valuechange.combineClaim++;
    }
    if (value == "taxonomyCode") {
      this.valuechange.taxonomyCode++;
    }
    if (value == "atypical") {
      this.valuechange.atypical++;
    }
    if (value == "umpiPayorUMPIMust") {
      this.valuechange.umpiPayorUMPIMust++;
    }
  }
  //////////////////////////////////Close POPUP///////////////////////////////////////
  cancel() {
    if ( this.valuechange.Status >1 ||  this.valuechange.Group > 1 || this.valuechange.Payor > 1 || this.valuechange.Service > 1
      || this.valuechange.Description > 1 || this.valuechange.billingUnit > 1 || this.valuechange.netRate > 1
      || this.valuechange.hcpcCode > 1 || this.valuechange.billIndividually > 1 || this.valuechange.revCode > 1
      || this.valuechange.companyIdentifier > 1 || this.valuechange.g2id > 1 || this.valuechange.npi > 1
      || this.valuechange.companyName > 1 || this.valuechange.name > 1 || this.valuechange.address1 > 1 || this.valuechange.address2 > 1
      || this.valuechange.city > 1 || this.valuechange.state > 1 || this.valuechange.zipcode > 1 || this.valuechange.facilityID > 1
      || this.valuechange.serviceLoc > 1 || this.valuechange.pharm > 1 || this.valuechange.homeVisit > 1 || this.valuechange.callTypeID > 1
      || this.valuechange.unitMultiplier > 1 || this.valuechange.rateChangeDate > 1 || this.valuechange.oldUCRate > 1 || this.valuechange.oldNetRate > 1
      || this.valuechange.waiverFlag > 1 || this.valuechange.combineClaim > 1
      || this.valuechange.waiverFlag > 1 || this.valuechange.taxonomyCode > 1 || this.valuechange.atypical > 1 ||
      this.valuechange.umpiPayorUMPIMust > 1
    ) {
      // $('#CloseModal').modal({
      //   show: true,
      //   zIndex: 1000000
      // })
      document.getElementById('openModal1').click()
    }
    else {

      this.showtable();
      this.getPayorTotalItem()
      this.payerLst = [];
    }

  }
  cancelYes() {
    this.showtable()
    this.getPayorTotalItem()
    document.getElementById('openModal1').click()
    this.payerLst = [];
  }
  ///////////////////////////////////////////////////////////////////////////
  filepermissionget() {
    let params = new URLSearchParams();
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    params.append("pagecode", "GroupPayorService");
    //params.append("roleId", this.global.roleId);
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.fp = data;
      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
  //============================== Tooltip =========================================================//
  headerCellInfo(args) {
    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);
  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',
        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  onResize(args) {
    if (this.ColumnArray != null && this.ColumnArray != undefined) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      this.SaveColumnwidth();
    }
  }
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].GrouppayorService.Columns;
    this.grid.columns.forEach(col => {
      this.arraycol[0].GrouppayorService.HideColumns.forEach(element => {
        if (col.headerText == element) {
          col.visible = false;
        }

      });
    });
    this.grid.showColumns(this.arraycol[0].GrouppayorService.ShowColumns);
    this.grid.hideColumns(this.arraycol[0].GrouppayorService.HideColumns);
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    this.grid.pageSettings.pageSize = this.arraycol[0].GrouppayorService.Pagesize
    this.ColumnArray.forEach(element => {
      if (element.column == 'Group') {
        const column = this.grid.getColumnByField('groupName');
        column.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Payor') {
        const column1 = this.grid.getColumnByField('payorName');
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Service') {
        const column2 = this.grid.getColumnByField('serviceName');
        column2.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Net Rate') {
        const column3 = this.grid.getColumnByField('netRate');
        column3.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Service Location') {
        const column4 = this.grid.getColumnByField('serviceLoc');
        column4.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Facility Name') {
        const column5 = this.grid.getColumnByField('name');
        column5.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Facility Address1') {
        const column5 = this.grid.getColumnByField('address1');
        column5.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Facility ID') {
        const column6 = this.grid.getColumnByField('facilityID');
        column6.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Billing Unit') {
        const column7 = this.grid.getColumnByField('billingUnit');
        column7.width = element.width;
        this.grid.refreshHeader();
      }
      else if (element.column == 'Actions') {
        const column8 = this.grid.getColumnByUid('Actions');
        column8.width = element.width;
        this.grid.refreshHeader();
      }
    });
  }
  SaveColumnwidth() {
    // this.arraycol[0].GrouppayorService.Columns = this.ColumnArray;
    // this.arraycol[0].GrouppayorService.Pagesize = this.grid.pageSettings.pageSize;
    // this.columnchange.userid = parseInt(this.global.userID);
    // this.columnchange.column = JSON.stringify(this.arraycol);
    // this.columnchange.id = this.id;
    // this.global.globalColumn = this.columnchange;
    // this.arraycol = JSON.parse(this.global.globalColumn.column);
    // let url = "api/ColumnChange/Savewidth?";
    // this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    //   this.getColumnwidth();
    // });
  }
  clearUpdaterate() {
    this.updateRatesInBulk = new UpdateRatesInBulk()
  }
  updateSeerviceRate() {
    let url = "api/PayerService/UpdateRatesInBulk";
    var saveList: any = JSON.parse(JSON.stringify(this.updateRatesInBulk));
    saveList.masterServiceId = saveList.masterServiceId?.toString();
    saveList.rateChangeDate = (saveList.rateChangeDate != null && saveList.rateChangeDate != undefined && saveList.rateChangeDate != '') ? this.global.getDateTimeString(this.updateRatesInBulk.rateChangeDate) : null;
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveList,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {
        this.toastrService.success('Service Rate Updated successfully!');
        document.getElementById('openservicerateModal').click()
        this.getPayorTotalItem();
      }
    }, (err: any) => {
      this.toastrService.error(err)
    })
  }
  getStatusLov() {
    let url = 'api/LOV/getLovDropDown?'
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.CommonAPI.getDropDownList('STATUS', params, url, "LovDropDown").then((data: any) => {


      const status = [...data]; // Create a shallow copy of data
      this.filterstatusList = [...data]; // Create another shallow copy of data
      let values = {
        "id": '00000000-0000-0000-0000-000000000000',
        "lovName": "ALL",
        "lovCode": "ALL",
        "lovValue": "ALL"
      };
      this.filterstatusList.push(values);
      this.statusList = status;
            
       this.FilterStatus = this.statusList?.filter(
        (st) => st.lovName == "Active"
      )[0].id;
      this.GroupPayorService.statusLid=this.FilterStatus;
      this.getPayorTotalItem();
    }, err => {
    })
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}



